export default __webpack_public_path__ + "static/media/undefined.da979bd6.PNG";